import { render, staticRenderFns } from "./PatientPersonalDataCard.vue?vue&type=template&id=294a212b&scoped=true&"
import script from "./PatientPersonalDataCard.vue?vue&type=script&lang=js&"
export * from "./PatientPersonalDataCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientPersonalDataCard.vue?vue&type=style&index=0&id=294a212b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a212b",
  null
  
)

export default component.exports